import React, { Component } from 'react';

import { connect } from "react-redux";

import axios from "axios";
import APIModel from "../../Models/APIModel";

import { AvForm, AvField } from 'availity-reactstrap-validation';
import { getRequestHeader, getTimesAgo } from '../../util/functions';

import {
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Nav,
	Col,
	Tooltip,
	NavItem,
	NavLink,
	Label,
	Button,
	Badge,
	Input,
	ListGroup,
	ListGroupItem,
	ListGroupItemHeading,
	ListGroupItemText
} from 'reactstrap';
import PropTypes from 'prop-types';

import { AppAsideToggler, AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/brand/logo.png'

// import SitesDropdown from './SitesDropdown';

import * as actions from "../../Store/Actions/AuthActions";
import * as siteActions from '../../Store/Actions';
import * as  types from "../../Store/Actions/types";
import { setTimeout } from 'core-js';

const propTypes = {
	children: PropTypes.node,
};

const defaultProps = {};



class DefaultHeader extends Component {

	state = {
		SiteID: this.props.user.SiteID,
		notificationsData: [],
		unReadNotificationCount: 0,
		// isUnreadNotificationIcon: false,
		tooltipOpen: false,
	}
	constructor(props) {
		super(props);
		this.toggleTooltip = this.toggleTooltip.bind(this);
		this.getAllNotification = this.getAllNotification.bind(this);

		// this.state = initialState;
	};


	toggleTooltip = () => {
		this.setState({
			tooltipOpen: !this.state.tooltipOpen
		})
	};

	renderUserName() {
		const { user } = this.props;
		if (user) {
			return (
				<NavItem className="mr-2">
					<NavLink >{`${user.FirstName} ${user.LastName}`}</NavLink>
				</NavItem>
			);
		}
	}

	getAllNotification = () => {
		// console.log('header props', this.props);

		let { user } = this.props;
		// this.setState({
		// 	unReadNotificationCount: 0
		// })

		let notificationCount = 0;

		if (user) {
			axios.get(APIModel.HOST + "Notification/GetAllNotifications", getRequestHeader(user.token)
			).then(response => {
							this.setState({ notificationsData: response.data });
	
				for (let i = 0; i < this.state.notificationsData.length; i++) {
					if (this.state.notificationsData[i].isRead == 0)
					{
						notificationCount = notificationCount+1;
					}
				}
					this.setState({
						unReadNotificationCount: notificationCount
					})
				setTimeout(this.getAllNotification.bind(this), 2000);
			}).catch(err => {
	
				if(err.response.status === 401) {
					this.props.history.push('/logout');
				}
			});
	
		}

      



	};

	markNotificationAsRead = (userNotificationID) =>
	{
		// alert(userNotificationID);
		let { user } = this.props;

		axios.get(APIModel.HOST + "Notification/UpdateNotification/" + userNotificationID + "/" + 1, getRequestHeader(user.token)).then(response => {
			this.getAllNotification();
			this.setState({
				// // isUnreadNotificationIcon: !this.state.isUnreadNotificationIcon
			})
		}).catch(this.errorHandler);

	}

	onChange = e => {
		
		const siteid = e.target.value;
		this.setState({ SiteID: siteid });
		const { changeSite, user, dispatch } = this.props;
		changeSite(user.token, { SiteID : siteid }).then(res => {
			const user = res.data;
			dispatch({
				type: types.CHANGE_SITE,
				payload: user
			});
			window.location.reload();
		}).catch(err => {
			let error = err.toString();
			if (err.response) {
				error = err.response.data.Message;
			}

			this.setState({ error });

			this.setState({
				isProcessing: false
			});

		});

	};

	componentDidMount() {
		this.getSites();
		this.getAllNotification();
		// setInterval(this.getAllNotification.bind(this), 2000);
	}


	renderSite = () => {
		const { ability,user, sites } = this.props;
		const { SiteID } = this.state;
		// console.log(this.props);

		if (ability("access-all-sites")) {
			return (
				<span>
					{/* <Label>Site</Label> */}
					<Input bsSize="sm" type="select" name="SiteID" value={SiteID} onChange={this.onChange}>
						<option key="" value="" >Select</option>
						{sites.map(g => (
							<option key={g.SiteID} value={g.SiteID}>{g.SiteName}</option>
						))}
					</Input>
				</span>
			);
		}

		return (
			// <Col style={{ paddingTop: "10px" }}>
				<span>{`${user.SiteName}`}</span>
			// </Col>
		);
	}

	renderUserAndSiteName() {
		const { user } = this.props;
		if (user) {
			return (
				<Nav className="" navbar>
					<NavItem className="d-md-down-none px-3">
						{`${user.Environment}`}
					</NavItem>
					<NavItem className="d-sm-down-none">
						<b>Site: </b>
					</NavItem>
					<NavItem className="siteListDropdown d-none d-sm-block">
						{this.renderSite()}
					</NavItem>
				</Nav>

				// <React.Fragment>
				// 	<Col style={{ paddingTop: "10px" }}>
				// 		<p></p>
				// 	</Col>
				// </React.Fragment>
			);
		}
	}

	getSites = () => {

		let { getSites, dispatch, user, authUser } = this.props;

		getSites(user.token).then(res => {

			dispatch({
				type: types.GET_SITES,
				payload: {
					sites: res.data,
					authUser
				}
			});
		});
	};

	render() {
		const { history } = this.props;
		let { notificationsData } = this.state;
		// const notificationsData= [{
		// 		NotificationID: 1,
		// 		NotificationHeader: 'First Notification Header',
		// 		NotificationDescription: 'First Notification Description',
		// 		CreatedOn: '01-11-2019'
		// 	}, {
		// 		NotificationID: 2,
		// 		NotificationHeader: 'Second Notification Header',
		// 		NotificationDescription: 'Second Notification Description',
		// 		CreatedOn: '01-11-2019'
		// 	}, {
		// 		NotificationID: 3,
		// 		NotificationHeader: 'Third Notification Header',
		// 		NotificationDescription: 'Third Notification Description',
		// 		CreatedOn: '01-11-2019'
		// 	}, {
		// 		NotificationID: 4,
		// 		NotificationHeader: 'Four Notification Header',
		// 		NotificationDescription: 'Four Notification Description',
		// 		CreatedOn: '01-11-2019'
		// 	}
		// ]
		let { user } = this.props;

		return (
			<React.Fragment>
				<AppSidebarToggler className="d-lg-none" display="md" mobile />
				<AppNavbarBrand
					full={{ src: logo, height: 40, alt: 'Logo' }}
					minimized={{ src: logo, height: 50, alt: 'Logo' }}
				/>
				<AppSidebarToggler className="d-md-down-none" display="lg" />
				{this.renderUserAndSiteName()}
				<Nav className="ml-auto" navbar>
					<NavItem className="d-md-down-none"> </NavItem>
					<AppHeaderDropdown direction="down">
						<DropdownToggle nav>
							<NavLink href="#">
								<i className="icon-bell"></i>
								<Badge pill color="danger">
									{this.state.unReadNotificationCount}
								</Badge>
							</NavLink>
						</DropdownToggle>

						<DropdownMenu className="notificationPane" right style={{ right: 'auto', 'top' : '25px', 'left' : '-250px', 'width' : '400px', 'maxHeight' : '500px', 'overflow' : 'auto', 'WebkitBoxShadow': '2px 10px 15px 10px rgba(0,0,0,0.1)', 'MozBoxShadow': '2px 10px 15px 10px rgba(0,0,0,0.1)', 'boxShadow': '2px 10px 15px 10px rgba(0,0,0,0.1)' }}>
							<DropdownItem header tag="div" className="text-center"><strong>You have {this.state.unReadNotificationCount} notifications.</strong></DropdownItem>
							<ListGroup>
								{notificationsData.map((notification, index) =>
									<ListGroupItem color={(notification.isRead == 1)? "secondary":"primary"}>

										<ListGroupItemHeading className="mb-0">
											{notification.NotificationHeader}
										</ListGroupItemHeading>

										<span style={{'top': '5px', 'right': '10px', 'position': 'absolute', 'fontSize': 'small', }}>
											{/* {notification.CreatedOn} */}
											{getTimesAgo(notification.CreatedOn)}
										</span>

										<ListGroupItemText className="mb-0" style={{'color': 'gray'}}>
											{notification.NotificationDescription}
											<span className="blockquote-footer">
												{
													( notification.CreatedBy == user.UserID ) ?
													<span title="Source Title">
														Sent by You
													</span>
													:
													<span title="Source Title">
														Sent by {notification.FirstName} {notification.LastName}
													</span>
												}
											</span>
										</ListGroupItemText>

										{
											(notification.isRead == 1) ?
											<Button size="sm" disabled className="p-0" color="link" style={{'bottom': '5px', 'right': '10px', 'position': 'absolute', 'fontSize': 'small', 'lineHeight': 'normal'}}>
												<i className="fa fa-envelope-open-o" />
											</Button>
											:
											<Button size="sm" className="p-0" color="link"  onClick={()=>this.markNotificationAsRead(notification.UserNotificationID)} style={{'bottom': '5px', 'right': '10px', 'position': 'absolute', 'fontSize': 'small', 'lineHeight': 'normal'}}>
												<i className="fa fa-envelope-o" id="notificationMarkAsRead"> </i>
												{/* <i className="fa fa-envelope-o" id="notificationMarkAsRead"> </i>
												<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="notificationMarkAsRead" toggle={this.toggleTooltip}>
														Mark as read
												</Tooltip> */}
											</Button>
										}

										{/* <i className="" style={{'bottom': '5px', 'right': '10px', 'position': 'absolute', 'fontSize': 'small', }} onClick={()=>this.}></i> */}

										{/* <i className="fa fa-envelope-open-o" style={{'bottom': '5px', 'right': '10px', 'position': 'absolute', 'fontSize': 'small', }}></i> */}

									</ListGroupItem>
								)}
							</ListGroup>
							{/* <DropdownItem className="p-1">
								<i className="fa fa-envelope-o ml-0"></i>
								New User Registered
								<i className="fa fa-envelope-o float-right mr-0" id="TooltipElement"></i>
								<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipElement" toggle={this.toggleTooltip}>
									Mark as read
								</Tooltip>
							</DropdownItem>
							<DropdownItem className="p-1">
								User Deleted
								<i className="fa fa-envelope-o float-right mr-0" id="TooltipElement"></i>
								<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipElement" toggle={this.toggleTooltip}>
									Mark as read
								</Tooltip>
							</DropdownItem>
							<DropdownItem className="p-1">
								Sales Report is ready
								<i className="fa fa-envelope-o float-right mr-0" id="TooltipElement"></i>
								<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipElement" toggle={this.toggleTooltip}>
									Mark as read
								</Tooltip>
							</DropdownItem>
							<DropdownItem className="p-1">
								New Client
								<i className="fa fa-envelope-o float-right mr-0" id="TooltipElement"></i>
								<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipElement" toggle={this.toggleTooltip}>
									Mark as read
								</Tooltip>
							</DropdownItem>
							<DropdownItem className="p-1">
								Server Overloaded
								<i className="fa fa-envelope-o float-right mr-0" id="TooltipElement"></i>
								<Tooltip placement="top" isOpen={this.state.tooltipOpen} target="TooltipElement" toggle={this.toggleTooltip}>
									Mark as read
								</Tooltip>
							</DropdownItem> */}
						</DropdownMenu>
					</AppHeaderDropdown>


					<AppHeaderDropdown direction="down">
						<DropdownToggle nav>

							<img src={'../../assets/img/avatars/10.png'} className="img-avatar d-none d-xl-block d-lg-block d-md-block" alt="user avatar" />

							<span className="userNameInDropDown d-none d-sm-block d-block d-xl-none d-lg-none d-md-none">
								<i className="fa fa-user-circle"></i>
								{this.renderUserName()}
							</span>
						</DropdownToggle>
						<DropdownMenu right style={{ right: 'auto' }}>

							<span className="d-xl-none d-lg-none d-md-none d-sm-none">
								<b>Site: </b>
								{this.renderSite()}
							</span>

							<DropdownItem onClick={() => history.push("/user/changePassword")}><i className="fa fa-wrench" /> Change Password</DropdownItem>
							<DropdownItem onClick={() => history.push("/logout")}><i className="fa fa-lock" /> Logout</DropdownItem>

						</DropdownMenu>
					</AppHeaderDropdown>
					<span className="d-none d-xl-block d-lg-block d-md-block">
						{this.renderUserName()}
					</span>
				</Nav>
				{/* <AppAsideToggler defaultOpen={false} className="d-md-down-none" /> */}
			</React.Fragment>
		);
	}
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapStateToProps = state => {
	return {
		user: state.auth.user,
		sites: state.SiteReducer.sites
	};
};

const mapDispatchToProps = () => {
	return {
		changeSite: (token, params) => actions.changeSite(token, params),
		getSites: (token) => siteActions.getSites(token),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DefaultHeader);
